<template>
  <div>
    <v-row justify="center">
      <v-dialog
          v-model="dialog"
          fullscreen
          hide-overlay
          transition="dialog-bottom-transition"
          @keydown.esc="avisoCerrar"
          persistent
        >
          <v-card tile>
            <v-toolbar
              flat
              dark
              color="primary"
            >
              <v-btn
                icon
                dark
                @click="avisoCerrar"
              >
                <v-icon>mdi-close</v-icon>
              </v-btn>
              <v-toolbar-title>
                <span v-if="!editandoTipoUsuario && !tipoUsuario.nombre">
                  Nuevo tipo usuario
                </span>
                <span>
                  {{ tipoUsuario.nombre }}
                </span>
              </v-toolbar-title>
              <v-spacer></v-spacer>
              <v-toolbar-items>
                <v-btn
                  dark
                  text
                  @click="guardar"
                  :disabled="$v.tipoUsuario.$invalid"
                >
                  Guardar
                </v-btn>
              </v-toolbar-items>
              <v-menu
                bottom
                right
                offset-y
              >
              </v-menu>
            </v-toolbar>
            <v-card-text>
              <v-expansion-panels
                v-model="panel"
                multiple
              >
                <v-expansion-panel class="mt-4">
                    <v-expansion-panel-header class="text-h6">Información Básica</v-expansion-panel-header>
                    <v-expansion-panel-content>
                      <v-row no-gutters>
                        <v-col cols="12">
                          <v-text-field
                            v-model="tipoUsuario.nombre"
                            label="Nombre"
                            prepend-icon="mdi-account-outline"
                            required
                            :error-messages="errorNombre"
                            @input="$v.tipoUsuario.nombre.$touch()"
                            @blur="$v.tipoUsuario.nombre.$touch()"
                            class="anadirAsterisco"
                          ></v-text-field>
                        </v-col>
                      </v-row>
                      <v-row>
                        <v-col cols="12">
                          <v-slider
                            v-model="tipoUsuario.valor"
                            thumb-label
                            ticks="always"
                            :tick-labels="[0.5,,,,,1,,,,, 1.5]"
                            tick-size="4"
                            prepend-icon="mdi-speedometer"
                            :max="1.5"
                            :min="0.5"
                            step="0.1"
                            label="Valor"
                          ></v-slider>
                        </v-col>
                      </v-row>
                      <v-row>
                      <v-col cols="12" class="pt-0 pb-0">
                        <v-textarea
                          prepend-icon="mdi-note-text-outline"
                          label="Observaciones"
                          v-model="tipoUsuario.observaciones"
                        ></v-textarea>
                      </v-col>
                    </v-row>
                    </v-expansion-panel-content>
                </v-expansion-panel>
                <v-expansion-panel>
                  <v-expansion-panel-header class="text-h6">Configuración</v-expansion-panel-header>
                  <v-expansion-panel-content>
                    <v-row>
                      <v-col cols="12">
                        <p class="font-weight-medium">
                          Aquí puedes habilitar o deshabilitar el tipo de usuario para impedir su acceso a la aplicación
                        </p>
                        <v-btn
                          color="warning"
                          class="ma-2"
                          outlined
                          v-if="tipoUsuario.habilitado"
                          @click="tipoUsuario.habilitado = 0"
                        >
                        <v-icon
                            left
                            dark
                          >
                            mdi-account-cancel-outline
                          </v-icon>
                          Deshabilitar
                        </v-btn>
                        <v-btn
                          color="success"
                          class="ma-2"
                          outlined
                          v-else
                          @click="tipoUsuario.habilitado = 1"
                        >
                        <v-icon
                            left
                            dark
                          >
                            mdi-account-check-outline
                          </v-icon>
                          Habilitar
                        </v-btn>
                      </v-col>
                    </v-row>
                  </v-expansion-panel-content>
                </v-expansion-panel>
                <v-expansion-panel v-if="editandoTipoUsuario">
                  <v-expansion-panel-header class="text-h6">Metadata</v-expansion-panel-header>
                  <v-expansion-panel-content>
                    <v-row>
                      <v-col cols="12">
                        <p class="font-weight-bold d-inline">Última modificación:</p> {{ formatearFecha(tipoUsuario.updated_at) }} por {{ usuarios[getPosicionIdUsuario(tipoUsuario.idUsuarioModificacion)].nombre }} {{ usuarios[getPosicionIdUsuario(tipoUsuario.idUsuarioModificacion)].apellidos }}
                      </v-col>
                    </v-row>
                    <v-row>
                      <v-col cols="12">
                        <p class="font-weight-bold d-inline">Fecha de creación:</p> {{ formatearFecha(tipoUsuario.created_at) }} por {{ usuarios[getPosicionIdUsuario(tipoUsuario.idUsuarioCreacion)].nombre }} {{ usuarios[getPosicionIdUsuario(tipoUsuario.idUsuarioCreacion)].apellidos }}
                      </v-col>
                    </v-row>
                  </v-expansion-panel-content>
                </v-expansion-panel>
              </v-expansion-panels>
            </v-card-text>
            <div style="flex: 1 1 auto;"></div>
          </v-card>
        </v-dialog>
    </v-row>
    <v-row justify="center">
      <v-dialog v-model="dialogCerrar" persistent max-width="380">
        <v-card>
          <v-card-title class="headline">¡Atención!</v-card-title>
          <v-card-text>Vas a salir sin guardar los cambios. ¿Estás seguro?</v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn text @click="dialogCerrar = false">Cancelar</v-btn>
            <v-btn color="error" text @click="cerrar">Salir</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-row>
  </div>
  
</template>

<script>
  import { mapState, mapActions } from 'vuex';
  import axios from 'axios';
  import { required } from 'vuelidate/lib/validators';
  import formatearFecha from '../../mixins/formatearFecha';
  export default {
    name: 'FullDialogTipoUsuario',
    mixins: [formatearFecha],
    data () {
        return {
            dialogCerrar: false,
            panel: [0,1,2]
        }
    },
    validations: {
      tipoUsuario: {
        nombre: { required }
      }
    },
    methods: {
      ...mapActions('tipoUsuario', ['setDialog', 'setTipoUsuario', 'setTiposUsuarios']),
      ...mapActions(['setLoading', 'setSnackbar']),
      avisoCerrar(){
        this.dialogCerrar = true;
      },
      cerrar(){
        this.dialogCerrar = false;
        this.setDialog(false);
        this.$v.$reset();
      },
      guardar(){
        console.log(this.tipoUsuario);
        this.setLoading(true);
        if(this.editandoTipoUsuario){
          axios.patch("/api/tipousuario", this.tipoUsuario).then(respuesta => {
            this.recuperarTiposUsuarios();
            this.setLoading(false);
            this.setDialog(false);
            this.setSnackbar({
                tipo: 'success',
                mensaje: 'Datos guardados correctamente'
            });
          }).catch(error =>{
            console.log(error);
            this.setLoading(false);
            this.setSnackbar({
                tipo: 'error',
                mensaje: 'Error. No se han podido guardar los datos'
            });
          });
        }else{
          axios.post("api/tipousuario", this.tipoUsuario).then(respuesta => {
            this.recuperarTiposUsuarios();
            this.setLoading(false);
            this.setDialog(false);
            this.setSnackbar({
                tipo: 'success',
                mensaje: 'Tipo de usuario creado correctamente'
            });
          }).catch(error => {
            this.setLoading(false);
            //console.log(error);
            this.setSnackbar({
                tipo: 'error',
                mensaje: 'Error. No se ha podido crear el tipo de usuario'
            });
          });
        }
      },
      recuperarTiposUsuarios(){
        axios.get("/api/tipousuario").then(respuesta => {
          this.setTiposUsuarios(respuesta.data);
        }).catch(error =>{
          //console.log(error);
          this.setSnackbar({
              tipo: 'error',
              mensaje: 'No se han podido recuperar los tipos de usuarios'
          });
        });
      },
      getPosicionIdUsuario(id){
        //Devuelve la posición del array usuarios del id Usuario que se le pasa
        return this.usuarios.findIndex(x => x.id === id);
      }
    },
    computed: {
      ...mapState('tipoUsuario', ['tipoUsuario', 'dialog', 'editandoTipoUsuario']),
      ...mapState('usuarios', ['usuarios']),
      errorNombre () {
        if (this.$v.tipoUsuario.nombre.$dirty){
          if (this.$v.tipoUsuario.nombre.$invalid){
            return 'Introduce el nombre del tipo de usuario';
          }
        }
      }
    },
    created(){

    }
  }
</script>